// extracted by mini-css-extract-plugin
module.exports = {"bb-quick-donate-widget":"bb-quick-donate-widget__33YdF","wrapper-container":"wrapper-container__kAUKx"};